import { styled } from "@mui/material/styles";

export const ContentBody = styled("div")`
  padding: ${(props) => props.theme.spacing(1)};
  box-sizing: border-box;

  @media print {
    padding: ${(props) => props.theme.spacing(1)} 0;
  }
`;
